import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    minWidth: 430,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    backgroundColor: Colors.white,
    padding: '1.5rem',
    borderRadius: 5,
    '@media (max-width: 500px)': {
      minWidth: 'calc(100vw - 5rem)',
    },
  },
  
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '2rem',
    padding: '0 0 1rem 0 ',
  },
  
  questionsContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '1.5rem',
    width: '100%',
    height: '100%',
    padding: '1.5rem',
    border: `1px solid ${Colors.lightGray}`,
    borderRadius: 5,
    flexWrap: 'wrap',
    '& > div': {
      width: 'calc(50% - 0.75rem)',
      '@media (max-width: 900px)': {
        width: '100%',
      },
    },
  },
  
  questions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '1rem',
    border: `1px solid ${Colors.gray}`,
    borderRadius: 3,
    backgroundColor: Colors.lightGray,
    textAlign: 'justify',
    height: '100%',
    minHeight: '16rem',
    gap: '1rem',
  },
  
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  
  statusBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  
  status: {
    padding: '0.5rem 1rem',
    textTransform: 'uppercase',
    color: Colors.white,
    fontSize: 11,
    backgroundColor: Colors.green,
    borderRadius: '3px',
    fontWeight: 'bold',
  },
  
}))

export default styles
